module.exports = __webpack_public_path__ + "static/media/scroll.c7e95a19.svg";